import { Box } from '@material-ui/core';
import { ReactNode } from 'react';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

interface AutomobileFormSectionProps {
  title: string;
  titleAdornment?: ReactNode;
  children: ReactNode;
}

export const AutomobileFormSection = ({ title, titleAdornment, children }: AutomobileFormSectionProps) => (
  <Box display="flex" flexDirection="column" gridGap={16}>
    <Box display="flex" alignItems="center" gridGap={8}>
      <Font variant="subtitle1" color="title">
        <strong>
          <Text tId={title} />
        </strong>
      </Font>
      {titleAdornment}
    </Box>
    {children}
  </Box>
);
